import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography,
  makeStyles,
  Avatar,
  Box,
  Chip,
  Grid,
} from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import React, { useEffect } from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import { useDispatch, useSelector } from 'react-redux';
import {
  SubtaskItemChangeStatusLogState,
  fetchSubtaskItemChangeStatusLogList,
} from '../../../../state/subtaskItemChangeStatusLog';
import { AppState } from '../../../../state/configureStore';
import { SubtaskItemStatusLabel } from '../../../../constants';
import { DateTimeDisplay } from '../../../components';
import { Close as CloseIcon } from '@material-ui/icons';
import PersonIcon from '@material-ui/icons/Person';
// removed OpenInNewIcon and IconButton to show static user icon only
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';

interface SubtaskItemTimelineDialogProps {
  open: boolean;
  subtaskItemId: number;
  handleClose: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return (
    <Slide direction="up" ref={ref} {...props} timeout={{ enter: 400, exit: 400 }} />
  );
});

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: 24,
    overflow: 'hidden',
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.96) 100%)',
    boxShadow: '0 24px 60px rgba(15, 23, 42, 0.18)',
  },
  dialogTitle: {
    padding: theme.spacing(2.5, 3, 1.5),
    background:
      'linear-gradient(135deg, rgba(29,78,216,0.06) 0%, rgba(37,99,235,0.12) 100%)',
    borderBottom: '1px solid rgba(37, 99, 235, 0.08)',
  },
  titleEyebrow: {
    fontSize: '0.72rem',
    fontWeight: 700,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    color: '#2563eb',
    marginBottom: theme.spacing(0.75),
  },
  titleText: {
    fontWeight: 700,
    color: '#0f172a',
    lineHeight: 1.2,
  },
  titleSubtitle: {
    marginTop: theme.spacing(0.75),
    color: '#64748b',
  },
  dialogContent: {
    padding: theme.spacing(2.5, 3),
    background:
      'radial-gradient(circle at top, rgba(37,99,235,0.05), transparent 30%), linear-gradient(180deg, #fbfdff 0%, #f8fafc 100%)',
  },
  timelineRoot: {
    padding: 0,
    margin: 0,
    '&::before': {
      display: 'none',
    },
  },
  timelineItem: {
    minHeight: 'auto',
  },
  oppositeContent: {
    flex: 0.3,
    paddingTop: theme.spacing(0.75),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flex: '0 0 110px',
      paddingRight: theme.spacing(1.25),
    },
  },
  dateRange: {
    display: 'inline-block',
    padding: theme.spacing(1, 1.25),
    borderRadius: 16,
    background: 'rgba(255,255,255,0.86)',
    border: '1px solid rgba(148, 163, 184, 0.14)',
    boxShadow: '0 8px 22px rgba(15, 23, 42, 0.06)',
    color: '#475569',
    lineHeight: 1.5,
  },
  paper: {
    padding: theme.spacing(2, 2.5),
    borderRadius: 20,
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,0.94) 100%)',
    border: '1px solid rgba(148, 163, 184, 0.16)',
    boxShadow: '0 14px 30px rgba(15, 23, 42, 0.08)',
  },
  timelineContent: {
    marginBottom: theme.spacing(2),
  },
  timelineDot: {
    width: 16,
    height: 16,
    boxShadow: '0 0 0 6px rgba(255,255,255,0.96), 0 10px 18px rgba(37, 99, 235, 0.18)',
  },
  timelineConnector: {
    background:
      'linear-gradient(180deg, rgba(37,99,235,0.26) 0%, rgba(148,163,184,0.12) 100%)',
    width: 3,
    borderRadius: 999,
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  chip: {
    fontWeight: 600,
    padding: theme.spacing(0.75, 1.25),
    fontSize: '0.82rem',
    height: 34,
    borderRadius: 999,
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.16)',
  },
  avatar: {
    width: 40,
    height: 40,
    background:
      'linear-gradient(135deg, rgba(29,78,216,0.16) 0%, rgba(37,99,235,0.32) 100%)',
    color: '#1d4ed8',
    fontWeight: 700,
  },
  arrowIcon: {
    fontSize: 14,
    color: '#94a3b8',
  },
  detailBlock: {
    marginTop: theme.spacing(1.25),
    display: 'grid',
    gap: theme.spacing(0.9),
  },
  detailRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: '#475569',
  },
  detailIcon: {
    fontSize: 18,
    color: '#64748b',
  },
  detailText: {
    color: '#0f172a',
  },
  dialogActions: {
    padding: theme.spacing(0, 3, 2.5),
    justifyContent: 'flex-end',
  },
  closeButton: {
    minHeight: 42,
    padding: theme.spacing(0.75, 1.75),
    borderRadius: 14,
    textTransform: 'none',
    fontWeight: 700,
    boxShadow: '0 10px 20px rgba(37, 99, 235, 0.16)',
  },
}));

const SubtaskItemTimelineDialog: React.FC<SubtaskItemTimelineDialogProps> = (props) => {
  const dispatch = useDispatch();
  const { open, handleClose, subtaskItemId } = props;
  const classes = useStyles();

  const { items: subtaskItemChangeStatusLogs } = useSelector<
    AppState,
    SubtaskItemChangeStatusLogState
  >((state) => state.subtaskItemChangeStatusLog);

  const getInitials = (name?: string) => {
    if (!name) return '';
    const parts = name.split(' ');
    return (parts[0]?.[0] || '') + (parts[1]?.[0] || '');
  };

  const getStatusColor = (status?: string) => {
    const s = (status || '').toString().toUpperCase();
    const explicitByStatus: Record<string, string> = {
      PENDING: '#2196f3',
      IN_PROGRESS: '#ff9800',
      DONE: '#4caf50',
      WAITING_FOR_SALES: '#00bcd4',
      WAITING_FOR_CUSTOMER: '#26a69a',
      REJECT: '#f44336',
      CUSTOMER_REJECT: '#e64a19',
      CLOSE: '#9e9e9e',
      WAITING_FOR_NPD: '#9c27b0',
      APPROVE_BY_NPD: '#4dd0e1',
    };

    // If status exists in the explicit map, return it
    if (explicitByStatus[s]) return explicitByStatus[s];

    // If status matches one of SubtaskItemStatusLabel keys, but not mapped above,
    // provide a deterministic color from a small palette to avoid duplicates.
    const palette = [
      '#3f51b5',
      '#8bc34a',
      '#ff5722',
      '#607d8b',
      '#e91e63',
      '#795548',
      '#ba68c8',
      '#4dd0e1',
      '#f06292',
      '#cddc39',
    ];

    const hashString = (str: string) => {
      let h = 0;
      for (let i = 0; i < str.length; i++) {
        h = (h << 5) - h + str.charCodeAt(i);
        h |= 0;
      }
      return h;
    };

    const idx = Math.abs(hashString(s || '')) % palette.length;
    return palette[idx];
  };

  useEffect(() => {
    if (open && subtaskItemId > 0) {
      dispatch(
        fetchSubtaskItemChangeStatusLogList(
          { 'SmSubtaskItemId.EqualsTo': subtaskItemId },
          {
            pageNumber: 0,
            pageSize: 999,
          },
        ),
      );
    }
  }, [dispatch, open, subtaskItemId]);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      maxWidth="md"
      fullWidth={true}
      PaperProps={{ className: classes.dialogPaper }}
    >
      <DialogTitle disableTypography className={classes.dialogTitle}>
        <Typography variant="h5" className={classes.titleText}>
          Timeline
        </Typography>
        <Typography variant="body2" className={classes.titleSubtitle}>
          Review every status transition, timing window, and response note for this
          subtask item.
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Timeline align="left" className={classes.timelineRoot}>
          {subtaskItemChangeStatusLogs.map((item, index) => {
            const toLabel = SubtaskItemStatusLabel[item.statusTo ?? ''] || item.statusTo;
            const fromLabel =
              SubtaskItemStatusLabel[item.statusFrom ?? ''] || item.statusFrom;
            return (
              <TimelineItem key={index} className={classes.timelineItem}>
                <TimelineOppositeContent className={classes.oppositeContent}>
                  <Typography variant="body2" className={classes.dateRange}>
                    <DateTimeDisplay value={item.startDate?.toString()} />
                    {' — '}
                    <DateTimeDisplay value={item.endDate?.toString()} />
                  </Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                  <TimelineDot
                    className={classes.timelineDot}
                    style={{ backgroundColor: getStatusColor(item.statusTo) }}
                  />
                  <TimelineConnector className={classes.timelineConnector} />
                </TimelineSeparator>
                <TimelineContent className={classes.timelineContent}>
                  <Paper
                    elevation={2}
                    className={classes.paper}
                    style={{ borderLeft: `4px solid ${getStatusColor(item.statusTo)}` }}
                  >
                    <Grid container spacing={1} alignItems="center">
                      <Grid item>
                        <Avatar className={classes.avatar}>
                          {item.userResponded?.fullName ? (
                            getInitials(item.userResponded.fullName)
                          ) : (
                            <PersonIcon />
                          )}
                        </Avatar>
                      </Grid>
                      <Grid item xs>
                        <Box className={classes.statusRow}>
                          <Chip
                            label={fromLabel}
                            className={classes.chip}
                            style={{
                              backgroundColor: getStatusColor(item.statusFrom),
                              color: '#fff',
                            }}
                          />
                          <ArrowForwardIosIcon className={classes.arrowIcon} />
                          <Chip
                            label={toLabel}
                            className={classes.chip}
                            style={{
                              backgroundColor: getStatusColor(item.statusTo),
                              color: '#fff',
                            }}
                          />
                        </Box>
                        <Box className={classes.detailBlock}>
                          {item.description ? (
                            <Box className={classes.detailRow}>
                              <ChatBubbleOutlineIcon className={classes.detailIcon} />
                              <Typography variant="body2" className={classes.detailText}>
                                {item.description}
                              </Typography>
                            </Box>
                          ) : null}
                          <Box className={classes.detailRow}>
                            <PersonIcon className={classes.detailIcon} />
                            <Typography
                              variant="subtitle2"
                              className={classes.detailText}
                            >
                              {item.userResponded?.fullName}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Paper>
                </TimelineContent>
              </TimelineItem>
            );
          })}
        </Timeline>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button
          onClick={handleClose}
          color="primary"
          variant="contained"
          startIcon={<CloseIcon />}
          className={classes.closeButton}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubtaskItemTimelineDialog;
